// extracted by mini-css-extract-plugin
module.exports = {"root":"Patient_root__H6co1"};